import React, { useContext } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { AuthContext } from '../../context/AuthContext';
import './TopNav.css';

export default function TopNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, logout } = useContext(AuthContext);

  const isLanding = location.pathname === '/';

  const handleLogout = () => {
    if (token) {
      logout();
      navigate('/', { replace: true });
    } else {
      alert('Please sign in first');
    }
  };

  const handleHome = () => {
    if (token) {
      navigate('/home');
    } else {
      navigate('/');
    }
  };

  const handleDashboard = () => {
    if (token) {
      navigate('/dashboard');
    } else {
      alert('Please sign in first');
    }
  };

  const handleSettings = () => {
    if (token) {
      navigate('/settings');
    } else {
      alert('Please sign in first');
    }
  };

  return (
    <header className="topnav">
      {/* Brand Section */}
      <div className="topnav-left">
        <Link to="/" className="brand" onClick={handleHome}>
          <img
            src={`${process.env.PUBLIC_URL}/AdobeStock_133441382.png`}
            alt="BaoBrain Logo"
            className="logo"
          />
          <span className="brand-name">BaoBrain</span>
        </Link>
      </div>

      {isLanding ? (
        /* Landing Page Navigation - Uses topnav-link to prevent black underlines */
        <nav className="topnav-center">
          <a href="https://app.baobrain.com/installation" className="topnav-link">
            <span className="nav-full">Installation Guide</span>
            <span className="nav-short">Install</span>
          </a>
          <a href="https://app.baobrain.com/everythingYouNeed" className="topnav-link">
            <span className="nav-full">Everything You'll Need</span>
            <span className="nav-short">Setup</span>
          </a>
          <a href="https://app.baobrain.com/contact" className="topnav-link">
            <span className="nav-full">Contact Us</span>
            <span className="nav-short">Contact</span>
          </a>
        </nav>
      ) : (
        /* Logged-in Navigation */
        <>
          <nav className="topnav-center-logged-in">
            <button className="text-btn" onClick={handleHome}>
              Home
            </button>
            <button className="text-btn" onClick={handleDashboard}>
              Dashboard
            </button>
          </nav>

          <div className="topnav-right-logged-in">
            <button
              className="icon-btn"
              aria-label="Settings"
              onClick={handleSettings}
            >
              <FiSettings size={20} />
            </button>
            <button
              className="text-btn logout-text-btn"
              onClick={handleLogout}
              aria-label="Sign Out"
            >
              Logout
            </button>
          </div>
        </>
      )}
    </header>
  );
}